import base from "apps/shared/cookie-consent/base";
import bdcEakademie from "apps/shared/cookie-consent/bdc-eakademie";
import surgeonTalk from "apps/shared/cookie-consent/surgeon-talk";

export default {
  base,
  "bdc-eakademie": bdcEakademie,
  "surgeon-talk": surgeonTalk
}
